import { render, staticRenderFns } from "./formRadio.vue?vue&type=template&id=0523dc2f&scoped=true"
import script from "./formRadio.vue?vue&type=script&lang=js"
export * from "./formRadio.vue?vue&type=script&lang=js"
import style0 from "./formRadio.vue?vue&type=style&index=0&id=0523dc2f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0523dc2f",
  null
  
)

export default component.exports